<template>
  <div id="home">
    <head-common ref="headCommonChild" :navList="navList1" :indexProp="indexProp1"></head-common>
    <div class="home-recommend">
      <!--<img src="./../../static/pic/recommend_bg.jpg">-->
      <div class="home-recommend-content">
        <ArraysData></ArraysData>
      </div>
    </div>
    <div class="home-content">
      <div class="home-content-search">
        <form class="home-content-search-form">
          <!--<label>快速搜索：</label>-->
          <input v-model="articleQuery.keyword" placeholder="关键字">
          <!--<input v-model="articleQuery.startTime" type="date">-
          <input v-model="articleQuery.endTime" type="date">-->
          <input class="search" type="submit" value="搜索" @click="searchClick">
        </form>
      </div>
      <!--<div v-for="item in pageSize" class="home-content-item">
        <article-list @articles="articles"></article-list>
      </div>-->
      <div class="home-content-item">
        <home-article-list ref="child" :searchAction="searchAction0" @searchResult="searchResult0" :page="articleQuery.number" :queryVo="articleQuery"></home-article-list>
      </div>
      <div v-if="pageSize === 0" style="height: 820px"></div>
      <div v-else-if="pageSize <= 3" style="height:205px"></div>
      <div class="home-content-page"
           @click="clickMore" @mouseleave="clickMoreLeave">
        <span v-if="getPageLast">没有更多啦(*^o^*)</span>
        <span v-else>加载更多</span>
      </div>
    </div>
    <div class="home-footer">
      <div class="home-footer-link">
        <span>首页</span><span>学习</span><span>爱好</span><span>其他</span>
      </div>
      <div class="home-footer-beian" style="width:500px;margin:0 auto;">
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=46010502000538">
          <img src="http://blog-qn.xueyuhuihui.com/%E5%A4%87%E6%A1%88%E5%9B%BE%E6%A0%87.png" style="float:left;"/>琼公网安备 46010502000538号</a>
        <a href="https://beian.miit.gov.cn/">琼ICP备2022003607号-1</a>
      </div>
    </div>
    <!--<simple-click-event v-bind:param-count="simpleClickEventData.paramCount" v-bind:param-title="simpleClickEventData.paramTitle"> my home</simple-click-event>-->
  </div>
</template>

<script>
  import HeadCommon from './HeadCommon.vue'
  import SimpleClickEvent from './common/SimpleClickEvent.vue'
  import ArraysData from './common/ArraysData.vue'
  import ArticleList from './articles/ArticleList.vue'
  import HomeArticleList from './articles/HomeArticleList.vue'

  export default {
    name: "Home",
    props: {

    },
    data: function () {
      return {
        indexProp1: 3,
        httpApi: process.env.API_HOST,
        simpleClickEventData:{
          paramCount:0,
          paramTitle:"雪域灰灰主页",
          aMoveActiveBg: "",
          aMoveActiveFont: "",
          onClickOne: false,
          onMoveOverOne: false
        },
        navList1: [
          {routeName: "userLogin", navName: "登录", onClickOne: false},
          {routeName: "UserInfo", navName: "其他", onClickOne: false},
          {routeName: "Study", navName: "学习", onClickOne: false},
          {routeName: "home", navName: "首页", onClickOne: false}
        ],
        articleQuery: {
          keyword: "",
          startTime: null,
          endTime:null,
          number: 0,
        },
        pageSize: 6,
        size: 3,
        searchAction0: false,
        searchResultFlag: false,
        getPageLast: false
      }
    },
    created() {
      this.initData();
    },
    methods: {
      searchClick: function() {
        this.articleQuery.number = 0;
        this.searchAction0 = true;
        this.$refs.child.searchQuery(this.articleQuery.number, this.size);
        console.log(this.articleQuery,this.searchAction0);
      },
      searchResult0: function(x, y) {
        this.getPageLast = x;
        this.articleQuery.number = y;
        console.log("searchResult0-:",this.getPageLast,this.articleQuery.number);
        //this.searchAction0 = data;
      },
      clickMore: function () {
        /*todo 判断是否拿到页数*/
        this.searchAction0 = true;
        if (!this.getPageLast){
          //this.getPageLast = false;
          this.articleQuery.number += 1;
          this.$refs.child.searchQuery(this.articleQuery.number, this.size);
        }
      },
      clickMoreLeave: function () {
        console.log("clickMoreLeave-getPageLast:",this.getPageLast, this.articleQuery.number);
        console.log(this.httpApi);
        /*this.$axios.get(this.httpApi + "/leet_code/solution", {})
          .then(res => {
            console.log(res)
          })
          .catch(err => {
            alert("查询失败" + err.status + err.statusText)
          })*/
      },
      initData: function () {
        console.log("initData-searchAction0,searchResultFlag:", this.searchAction0, this.searchResultFlag);
      }
    },
    components: {
      HomeArticleList,
      HeadCommon,
      SimpleClickEvent,
      ArraysData,
      ArticleList
    }
  }
</script>

<style scoped>
  div, img, ul, li, p, label, input{margin: 0 auto; padding: 0; border: 0;}
  #home {
    width: 1000px;
    /*height: 1770px;*/
    border-width: 0;
    border-style: dotted;
    border-color: aqua;
    background: rgba(178, 255, 166, 0.44);
  }
  #home .home-recommend{
    position: relative;
    display: inline-block;
    width: 100%;/*填充*/
    height: 500px;
    background: url('./../../static/pic/recommend_bg.jpg') no-repeat;
    background-size: 100%;
    overflow: hidden;
  }
  #home .home-recommend .home-recommend-content{
    position: relative;
    display: inline-block;
    width: 90%;
    height: 80%;
    line-height: 80%;
    padding: 5%;
    /*background: rgba(113, 255, 211, 0.11);*/
  }
  #home .home-content {
    display: inline-block;
    width: 100%;
    min-height: 500px;
    float: left;
  }
  #home .home-content .home-content-search{
    margin: 5px;
    display: inline-block;
    width: 98%;
    height: 60px;
    font-size: 25px;
    text-align: right;
    background: #42eaff;
  }
  #home .home-content .home-content-search .home-content-search-form{
    margin: 5px;
    display: inline-block;
    text-align: left;
  }
   .home-content .home-content-search .home-content-search-form label, input {
    display: inline-block;
    margin: 10px;
    width: 180px;
    height: 30px;
    font-size: 20px;
    text-align: center;
    border-radius: 10px;
    transition: font-size 0.1s ease-in-out;
    border-style: solid;
    border-width: 2px;
    outline: none;/*框内没有线条*/
    border-color: #9ecaed;
    box-shadow: 0 0 10px #9ecaed;/*x y 模糊 颜色阴影*/
  }
  #home .home-content .home-content-search .home-content-search-form .search {
    display: inline-block;
    width: 60px;
    height: 30px;
    text-align: center;
    border-radius: 5px;
    background:radial-gradient(60px 30px at 20px 20px, rgba(0, 196, 255, 255) 50%, rgba(0, 22, 155, 118.01) 100%);
    /*background-image: radial-gradient(shape size at position, start-color, ..., last-color);*/
  }
  #home .home-content .home-content-search .home-content-search-form .search:active {
    background: #ffe9e9;
    color: #9fc1ff;
  }
  .search:focus{
    font-size: 20px;
  }
  input:focus {
    font-size: 21px;
    border-style: inset;
    /*box-shadow: 0 0 15px #9ecaed;*//*x y 模糊 颜色阴影*/
  }
  #home .home-content .home-content-item {
    margin: 5px;
    display: inline-block;
    width: 98%;/*/320px;/*/
    min-height: 400px;
    font-size: 20px;
    background: #42eaff;
  }
  #home .home-content .home-content-page{
    display: inline-block;
    margin: 5px;
    width: 98%;
    height: 50px;
    float: bottom;
    font-size: 20px;
    background: #42eaff;
  }
  #home .home-content .home-content-page span{
    position: relative;
    top: 12px;
    text-align: center;
  }
  #home .home-footer {
    display: inline-block;
    width: 100%;
    height: 100px;
    border-style: solid;
    border-color: #797979;
    border-width: 2px 0;
    border-radius: 10px;
  }
  #home .home-footer .home-footer-link {
    display: inline-block;
    margin: 10px auto;
    height: 50px;
    font-size: 30px;
    size: 70px;
    text-align: center;
  }
  #home .home-footer .home-footer-link span{
    margin: 10px 0;
    padding: 0 10px;
    border-style: solid;
    border-color: #000;
    border-width: 0 1px;
  }
  #home .home-footer .home-footer-beian{
    display: flex;
    flex-direction: row;
    margin: 10px 0;
    padding: 0 10px;
  }
  #home .home-footer .home-footer-beian a{
    margin: 0 10px;
  }
  /*自定义模版class名称*/
  .aMoveOver {
    background-color: blue;
    color: green;
  }
  .aClick {
    background-color: #1bc6ff;
    color: green;
  }
  .auto-color-font {
    mask-image: linear-gradient(to right, red, orange, yellow, green, cyan, blue, purple);
    background-image: linear-gradient(to right, red, orange, yellow, green, yellow, orange, red, orange, yellow, green, yellow, orange, red);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-size: 200% 100%;
    animation: colorMove 5s infinite linear;/*infinite 播放次数无限 linear 从头到位速度是相同的*/
  }
  /*规定动画*/
  @keyframes colorMove {
    from {
      /*给图像应用色相旋转*/
      filter: hue-rotate(0);
    }
    to {
      filter: hue-rotate(4turn);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue